module.exports = __webpack_public_path__ + "img/cover6.c3f87278.jpg";